module.exports = __webpack_public_path__ + "static/img/telephone.9cbe969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/telephone.svg
// module id = pkxi
// module chunks = 0